module.exports = __webpack_public_path__ + "img/icon-deposit-active.144339df.png";